import { Documents } from "@ca-dmv-radv/screens/src/dashboard/helpers/constants";

export const getExpirationTranslationKey = (documentType, isNch) => {
  let translationKey = "Expiration-form-Expiration-invalid-date";

  if (
    documentType === Documents.DRIVERS_LICENSE ||
    documentType === Documents.CA_DRIVERS_LICENSE
  ) {
    translationKey += "-dl";
    return {
      key: translationKey,
      default:
        "Expiration Date cannot be more than one year after the original expiration date or more than 10 years from today.",
    };
  }
  if (
    documentType === Documents.ID_CARD ||
    documentType === Documents.CA_ID_CARD
  ) {
    return {
      key: translationKey,
      default:
        "Expiration Date cannot be more than one year after the original expiration date or more than 10 years from today.",
    };
  }
  if ([Documents.PASSPORT, Documents.PASSPORT_CARD].includes(documentType)) {
    if (isNch) {
      translationKey += "-passport-nch";
      return {
        key: translationKey,
        default:
          "Expiration date must be at least 2 days from today and not more than 10 years from today.",
      };
    }
    translationKey += "-passport-id";
    return {
      key: translationKey,
      default:
        "Expiration date must be at least 30 days from today and not more than 10 years from today.",
    };
  }

  return {
    translationKey: "",
    default: "Expiration date must be valid, unexpired",
  };
};
